import React from 'react'
import {Alert, Col, Row, Table} from "antd";
import {noteToParagraph, printPrice} from "../../helpers";
import dayjs from "dayjs";

export default function OrderOverview({order, isSeller=false}) {

    if (!order) {
        return null;
    }

    const messageRole = isSeller ? "seller" : "buyer";

    let orderTotal = 0
    order.lines.forEach((line) => {
        orderTotal += line.price * line.quantity;
    });

    return (
        <>
            <h1>Bestelling #{order.id}</h1>
            {order.status === "paid" && (
                <Alert type={"success"} description={"Bestelling is betaald!"}/>
            )}
            <Row className={"mar-t-1"}>
                <Col md={8} xs={24}>
                    <h2>Koper</h2>
                    <p>
                        {order.name} <br/>
                        {order.address} <br/>
                        E: <a href={`mailto:${order.email}`}>{order.email}</a><br/>
                        T: <a href={`tel:${order.phone}`}>{order.phone}</a><br/>
                    </p>
                </Col>
                <Col md={8} xs={24}>
                    <h2>Verkoper</h2>
                    <p>
                        {order.company.name} <br/>
                        {order.company.is_phone_enabled && (
                            <>T: <a
                                href={`tel:${order.company.contact_phone}`}>{order.company.contact_phone}</a><br/></>
                        )}

                    </p>
                </Col>
                <Col md={8} xs={24}>
                    <h2>Levering</h2>
                    {order.delivery_method === "appointment" && (
                        <p>
                            Er is gekozen om een afspraak te maken via Oogst.app
                        </p>
                    )}

                    {order.delivery_method === "pickup_slot" && (
                        <p>
                            De bestelling wordt opgehaald
                            op <strong>{order.pick_up_date_time}</strong> bij <strong>{order.company.name}</strong>.
                        </p>
                    )}
                    {order.delivery_method === "stall" && (
                        <p>
                            De bestelling wordt/is opgehaald via de kraam.
                        </p>
                    )}
                </Col>
            </Row>
            <Row className={"mar-t-1"}>
                <Col md={24} xs={24}>
                    <h2>Bestelde producten</h2>
                    <Table style={{width: '100%'}} rowKey={(record) => `line-${record.id}`} pagination={false} dataSource={order.lines} columns={[
                        {title: 'Product', key: 'title', render(record) {
                            return (
                                <span>{record.quantity}x {record.title}</span>
                            )
                            }},
                        {
                            title: 'Prijs', responsive:['md'], dataIndex: 'price', key: 'price', render(price) {
                                return printPrice(price);
                            }
                        },
                        {
                            title: 'Totaal', className:"text-right", key: 'id', render(line) {
                                return printPrice(line.price * line.quantity);
                            },
                            onHeaderCell: () => {
                                return {
                                    style: {
                                        textAlign: 'right',
                                    },
                                };
                            }
                        },
                    ]}>
                    </Table>
                    {orderTotal && (
                        <div className={"text-right"} style={{paddingRight: '1em'}}>
                            <h3 className={"mar-t-1"}>Totaal: {printPrice(orderTotal)}</h3>
                        </div>
                    )}
                </Col>
            </Row>
            <h1 className={"mar-t-1"}>Correspondentie</h1>
            {order.messages.map((message) => {
                return (
                    <div key={`m`+message.id} className={"mar-b-1 message-box"}>
                        <Row>
                            <Col md={12} offset={ message.sender === messageRole ? 12 : 0}>
                                <Alert type={message.sender === messageRole ? 'info' : 'success'} description={(
                                    <>
                                        {noteToParagraph(message.content)}
                                        <div style={{fontSize: '10px', textAlign: 'right'}}>{dayjs(message.sent_at).fromNow()}</div>
                                    </>
                                )}>
                                </Alert>
                            </Col>
                        </Row>
                    </div>
                );
            })}


        </>
    )
}